<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :submit="submit" :canSubmit="false"
    :status="status" parentStoreName="Notifications_cms">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <label v-if="data.user_id && data.user_id.profile_picture"><img
                  :src="data.user_id ? data.user_id.profile_picture : ''" alt="User profile"></label>
              <label><span>A</span></label>
            </v-col>
            <v-col>
              <label>{{ data.user_id ? `${data.user_id.name || ''} ${data.user_id.last_name || ''}` : "" }}</label>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" readonly v-model="data.title" label="Title"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <label>Descripcion</label>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" solo rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="message" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" readonly v-model="data.message" label="Message"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="type_notification" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" readonly v-model="data.type_notification"
                  label="Tipo de notificacíon"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Notifications_cms.status
    })
  },
  data() {
    return {
      storeName: "Notifications_cms",
      title: "Notificacíon cms",
      data: {
        title: "",
        description: "",
        is_read: false,
        is_new: true,
        message: "",
        type_notification: "",
        request_extraction_id: "",
        user_id: ""
      }
    };
  }
};
</script>
